import React from 'react';
import * as Yup from 'yup';

import { Form } from '@dashboard/components/Formik';

import usePage from '@dashboard/hooks/usePage';

Yup.setLocale({
  mixed: {
    required: ({ path }) => `${path} is required`,
  },
});

const FormEditForm = () => {
  const { page, updatePage } = usePage();

  return (
    <Form
      initialValues={{
        title: page.title,
        images: page.images,
      }}
      onSubmit={async (values, actions) => {
        const { data, error } = await updatePage.mutateAsync({
          title: values.title,
          images: values.images,
        });

        actions.resetForm({
          values: {
            title: data.title,
            images: data.images,
          },
        });

        return {
          data: data,
          error: error,
        };
      }}
      fields={[
        {
          name: 'title',
          label: 'Title',
          type: 'text',
          placeholder: 'Title',
          autoFocus: true,
          optional: true,
        },
        {
          name: 'images',
          label: 'Images',
          type: 'images',
          optional: true,
        },
      ]}
    />
  );
};

export default FormEditForm;
